import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box, Container } from "@material-ui/core";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";

import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import ArchiveOutlinedIcon from "@material-ui/icons/ArchiveOutlined";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    flexDirection: "column",
  },
  root: {
    paddingBottom: theme.spacing(2),
  },
  iconDiv: {
    height: "100",
    marginRight: "15px",
  },
  textDiv: {
    paddingTop: 0,
  },
}));

function Notice() {
  const classes = useStyles();
  return (
    <Fragment>
      <Container className={classes.main}>
        <Box className={classes.root} display="flex" alignItems="top">
          <div className={classes.iconDiv}>
            <LocalShippingOutlinedIcon fontSize="large" />
          </div>
          <div className={classes.textDiv}>
            <Typography variant="h6" align="left" gutterBottom>
              Arrival at Warehouse
            </Typography>
            <Typography variant="body2" align="left">
              When a package arrives at the warehouse, the package will be registered in our system by our delivery team.
            </Typography>
          </div>
        </Box>
        <Box className={classes.root} display="flex" alignItems="top">
          <div className={classes.iconDiv}>
            <ArchiveOutlinedIcon fontSize="large" />
          </div>
          <div className={classes.textDiv}>
            <Typography variant="h6" align="left" gutterBottom>
              Importing
            </Typography>
            <Typography variant="body2" align="left">
              Arrived packages are sorted by our delivery team based on the private address code. This process can take up to 5 working days at the latest.
            </Typography>
          </div>
        </Box>
        <Box className={classes.root} display="flex" alignItems="top">
          <div className={classes.iconDiv}>
            <AssignmentTurnedInOutlinedIcon fontSize="large" />
          </div>
          <div className={classes.textDiv}>
            <Typography variant="h6" align="left" gutterBottom>
              Check Delivey List
            </Typography>
            <Typography variant="body2" align="left">
              Packages with imported status will be showed on your delivery list and the actual package will be stored in your address box.
            </Typography>
          </div>
        </Box>
        <Box display="flex" alignItems="top">
          <div className={classes.iconDiv}>
            <HelpOutlineOutlinedIcon fontSize="large" />
          </div>
          <div className={classes.textDiv}>
            <Typography variant="h6" align="left" gutterBottom>
              Missing Packages?
            </Typography>
            <Typography variant="body2" align="left">
              If your package status is imported but not on your delivery list, please leave a package claim request via the customer support.
            </Typography>
          </div>
        </Box>
      </Container>
    </Fragment>
  );
}

export default Notice;
